import React from 'react';
import styles from './MessageModal.module.scss';

interface MessageModalProps {
    /** Centered visual at the top of the card (e.g. a gif or icon). */
    icon?: React.ReactNode;
    title?: string;
    message: string;
    onClose: () => void;
}

/**
 * Shared message modal: a centered card with an optional icon/gif, title and
 * message, and a circular close button below it. Presentation-only.
 */
const MessageModal: React.FC<MessageModalProps> = ({ icon, title, message, onClose }) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.container} onClick={e => e.stopPropagation()}>
                <div className={styles.modal}>
                    <button className={styles.closeButton} onClick={onClose} aria-label="Close">
                        ✕
                    </button>
                    {icon && <div className={styles.iconWrap}>{icon}</div>}
                    {title && <h2 className={styles.title}>{title}</h2>}
                    <p className={styles.message}>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default MessageModal;
